import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

export type LabelFunction = (value: any) => string;
export type CompareFunction = (active: any, fromList: any) => boolean;

export type DropdownObjectItem<T> = { id: string; label: string; value: T };
export type DropdownItem<T> = string | DropdownObjectItem<T>;

@Component({
  selector: 'now-wbsuche-lib-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  imports: [CommonModule]
})
export class DropdownComponent<T> {
  @Input({ required: true }) public id!: string;
  @Input() public label = 'Auswahlmenü';
  @Input() public disabled = false;
  @Input({ required: true }) public possibleValues: DropdownItem<T>[] = [];
  @Input() public selectedValue?: DropdownItem<T>;
  @Input() public title?: string;
  @Input() public optionLabelFunction: LabelFunction = (value) => value;
  @Input() public optionCompareFunction: CompareFunction = (active, fromList) =>
    active === fromList;
  @Input() afterLabelTemplate?: TemplateRef<any>;

  @Output() public selectionChanged = new EventEmitter<DropdownItem<T>>();

  public onChange(event: Event) {
    const selectEvent = event as Event & { target: HTMLSelectElement };
    const value = selectEvent.target.value;
    const selectedItem = this.possibleValues.find((possibleValue) => {
      return value === this.getId(possibleValue);
    });
    if (!this.optionCompareFunction(this.selectedValue, selectedItem)) {
      this.selectionChanged.emit(selectedItem);
    }
  }

  getId(item: DropdownItem<T>): string {
    return typeof item === 'string' ? item : item.id;
  }
}
